import {
  PRODUCT_SEARCH_INDEXES,
  SEARCH_INDEXES,
} from '@bulknutrients/bulk-shared-lib/constants';
import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';
import type { IndexResult } from '@hooks/useSearch';

import { AmbassadorsList } from './SearchResultsLists/SearchResultsAmbassadors';
import { BlogList } from './SearchResultsLists/SearchResultsBlogs';
import { CategoriesList } from './SearchResultsLists/SearchResultsCategories';
import { ExpertsList } from './SearchResultsLists/SearchResultsExperts';
import { FaqsList } from './SearchResultsLists/SearchResultsFaqs';
import { PagesList } from './SearchResultsLists/SearchResultsPages';
import { ProductList } from './SearchResultsLists/SearchResultsProducts';

export function SearchResults({
  index,
  data,
}: {
  index: string;
  data: IndexResult[];
}) {
  const hits = data.find((d) => d.index === index)?.hits ?? [];

  return (
    <BulkErrorBoundary location="Search results list">
      {PRODUCT_SEARCH_INDEXES.includes(index) && (
        <ProductList products={hits} />
      )}
      {index === SEARCH_INDEXES.BLOGS && <BlogList data={hits} />}
      {index === SEARCH_INDEXES.PAGES && <PagesList data={hits} />}
      {index === SEARCH_INDEXES.AUTHORS && <ExpertsList data={hits} />}
      {index === SEARCH_INDEXES.AMBASSADORS && <AmbassadorsList data={hits} />}
      {index === SEARCH_INDEXES.CATEGORIES && <CategoriesList data={hits} />}
      {index === SEARCH_INDEXES.FAQS && <FaqsList data={hits} />}
    </BulkErrorBoundary>
  );
}
